import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/**
 * "Opponent proposed a draw" notification. Subject is the battle's discussion.
 * content: { proposerName }
 */
export default class DrawProposedNotification extends Notification {
  icon() {
    return 'fas fa-handshake';
  }
  href() {
    const discussion = this.attrs.notification.subject();
    return discussion ? app.route.discussion(discussion) : '#';
  }
  content() {
    var _ref, _user$displayName;
    const user = this.attrs.notification.fromUser();
    const content = this.attrs.notification.content() || {};
    const name = (_ref = (_user$displayName = user == null ? void 0 : user.displayName()) != null ? _user$displayName : content.proposerName) != null ? _ref : '?';
    return app.translator.trans('forumaker-arena.forum.notifications.draw_proposed_text', {
      proposer: m("strong", null, name)
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/DrawProposedNotification', DrawProposedNotification);